import { useI18n } from "../i18n/LanguageContext";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useI18n();
  return (
    <div
      data-testid="language-switcher"
      className={`flex items-center rounded-full border border-white/10 bg-[#05101f]/60 p-0.5 font-mono text-[12px] ${className}`}
    >
      {["en", "it"].map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            data-testid={`lang-${code}`}
            onClick={() => setLang(code)}
            aria-label={`Switch language to ${code.toUpperCase()}`}
            aria-pressed={active}
            className={`px-2.5 py-1 rounded-full uppercase transition-colors duration-300 ${
              active
                ? "bg-[#1E6FFF] text-white"
                : "text-[#A7B4C2] hover:text-[#4BE3FF]"
            }`}
          >
            {code}
          </button>
        );
      })}
    </div>
  );
};
